import {Component, Injector, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
    ArticleDto,
    BasketArticleDto,
    CategoryDto,
    CategoryServiceProxy,
    IBasketArticleDto,
    OrderGuideSimpleDto,
    PagedResultDtoOfArticleDto,
    PagedResultDtoOfOrderGuideSimpleDto,
    WebShopServiceProxy
} from '@shared/service-proxies/service-proxies';
import {AppComponentBase} from '@shared/common/app-component-base';

import {Subscription, throwError} from 'rxjs';

import {appModuleAnimation, PrimengTableHelper} from '@axilla/axilla-shared';
import * as _ from 'lodash-es';

import {Table} from 'primeng/table';
import {Paginator} from 'primeng/paginator';
import {LazyLoadEvent, MenuItem} from 'primeng/api';

import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';
import {AppConsts} from '@shared/AppConsts';
import {WebshopItemDetailsModalComponent} from '@app/webshop/shop/webshop-item-details-modal.component';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';
import {CombineViewService} from '@app/webshop/shared/services/combine-view.service';
import {NgxSpinnerService} from '@node_modules/ngx-spinner';
import {debounceTime, finalize, take, takeUntil} from 'rxjs/operators';
import {Subject} from '@node_modules/rxjs';
import {FormControl, FormGroup } from '@angular/forms';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';

@Component({
    templateUrl: './webshop.component.html',
    styleUrls: ['../dashboard/dashboard.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class WebshopComponent extends AppComponentBase implements OnInit, OnDestroy {

    @ViewChild('webshopItemDetails', {static: false}) webshopItemDetailsModal: WebshopItemDetailsModalComponent;

    @ViewChild('dataTable', {static: true}) dataTable: Table;
    @ViewChild('paginator', {static: true}) paginator: Paginator;

    orderGuideId: string;
    categoryId: string;
    hideSearch = true;
    isLoading = false;
    filter = '';
    changeRouter$: Subscription;
    // products: BasketArticleDto[];
    sortKey = '';
    rowsAmount = 9;
    isCategoryMode = false;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    navItems: MenuItem[];
    home: MenuItem;
    //#region search form related fields
    webshopCode: any;
    webshopTitle: any;
    primeng: PrimengTableHelper;
    typingTimer: any;
    doneTypingInterval = 500;

    protected readonly destroy$ = new Subject<void>(); // Used to signal unsubscription

    spinnerService: NgxSpinnerService;
    private _fieldAgentOrderService: FieldAgentOrderService;
    private _orderStateService: OrderStateService;
    private _combineViewService: CombineViewService;

    constructor(
        injector: Injector,
        private categoryServiceProxy: CategoryServiceProxy,
        private webShopServiceProxy: WebShopServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private route: ActivatedRoute,
        private _webshopService: WebshopService,
    ) {
        super(injector);

        this.spinnerService = injector.get(NgxSpinnerService);
        this._fieldAgentOrderService = injector.get(FieldAgentOrderService);
        this._orderStateService = injector.get(OrderStateService);
        this._combineViewService = injector.get(CombineViewService);

        this._setModeAndType();

        this._clearGlobalFilter();
    }

    private _clearGlobalFilter() {
        if (this.webshopService.globalSearchForm.value.filter) {
            this.webshopService.globalSearchForm.reset();
        }
    }

    private _orderGuide: OrderGuideSimpleDto;

    //#endregion Getting data

    get orderGuide() {
        return this._orderGuide;
    }

    set orderGuide(value: OrderGuideSimpleDto) {
        this._orderGuide = value;
    }

    private _category: CategoryDto;

    get category() {
        return this._category;
    }

    set category(value: CategoryDto) {
        this._category = value;
    }

    onloadDataCB: any;


    filterForm: FormGroup;
    readonly modelChange$ = new Subject();
    get toggleState(): number {
        if (this.filterForm) {
            return this.filterForm.get('toggleState').value;
        }
        return 1;
    }
    set toggleState(value: number) {
        this.filterForm.get('toggleState')?.setValue(value);
    }
    private _toggleState = 1; // Initial state


    ngOnInit(): void {
        this.initEvents();

        this._combineViewService.flush();
        this._onRouteChange();

        this.registerEvents(true);

        this.home = {icon: 'pi pi-home', url: 'app/webshop/dashboard'};

        if (this.isOuBlocked) {
            this.showIsBlockedMessage();
        } else {
            this.checkIsOuBlocked();
        }

        this._initFilterForm();
    }

    ngOnDestroy(): void {
        if (this.changeRouter$) {
            this.changeRouter$.unsubscribe();
        }

        this.registerEvents(false);
    }

    //#region Initialization

    private _initFilterForm() {
        this.filterForm = new FormGroup({
            toggleState: new FormControl(this._toggleState),
        });

        this.modelChange$
            .pipe(
                // Set appropriate debounce time
                debounceTime(300),
                //take(1)
            ).subscribe(() => {
            this.loadData();
        });
    }

    onStateChange(newState: number): void {
        console.log('New State:', newState);
        this.toggleState = newState;
        this.loadData();
    }

    //#region Register To Events func
    private registerEvents(on: boolean): void {
        if (on) {
            //Subscribe
            abp.event.on('app.globalSearch.loadData', this.onloadDataCB);
        } else {
            //Unsubscribe
            abp.event.off('app.globalSearch.loadData', this.onloadDataCB);
        }
    }


    private initEvents() {
        //Call Register To Events func
        this.onloadDataCB = () => {
            this.loadData();
        };


    }

    openDetails(item: any) {
        let article = (item.data ?? item) as ArticleDto;
        this.webShopServiceProxy.getArticle(article.id).subscribe();

        this.webshopItemDetailsModal.show(item);
    }

    getTypeByMode() {
        if (this.isCategoryMode) {
            this.orderGuide = null;

            this.getCategory();
            this._loadDataCategories();
        } else {
            this.category = null;

            this.getOrderGuide();
            this._loadDataOG();
        }
    }

    //#endregion Initialization
    get getIsCategoryMode() {
        return window.location.pathname.indexOf('categories') > -1;
    }

    loadData(event?: any) {
        if (this.getIsCategoryMode) {
            this._loadDataCategories(event);
        } else {
            this._loadDataOG(event);
        }
    }

    searchAndLoadData(data: any) {
        let event = data.event || null;

        this.webshopCode = data.webshopCode;
        this.webshopTitle = data.webshopTitle;
        this.primeng = data.primeng;

        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.loadData.bind(this, event), this.doneTypingInterval);
    }

    //#region Getting data

    get guidedNavItems() {
        return this._fieldAgentOrderService.getBreadCrumbs();
    }

    getOrderGuide() {
        this.webShopServiceProxy.getOrderGuidesOverview(this.orderGuideId, undefined, undefined, undefined, undefined, undefined, undefined)
            .subscribe((result: PagedResultDtoOfOrderGuideSimpleDto) => {
                this.orderGuide = result.items[0];
                if (this.orderGuide && this.orderGuide.name) {
                    this.navItems = [
                        {label: 'Order guides'},
                        {label: this.orderGuide.name, url: this._router.url}
                    ];

                }
            });
    }

    get isDisabled(): boolean {
        return this.webshopService.basketCounterValue ===  0;
    }
    getCategory() {
        this.categoryServiceProxy.get(this.categoryId)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe((result: CategoryDto) => {
                this.category = result;
                if (this.category && this.category.name) {
                    this.navItems = [
                        {label: 'Categories'},
                        {label: this.category.name, url: this._router.url}
                    ];
                }
            });
    }

    goToBasket() {
        this.webshopService.goToBasket();
    }

    //#endregion search form related fields

    preventClick($event: Event) {
        $event.stopPropagation();
    }

    resetQuantity(article: BasketArticleDto) {
        article.quantity = 0;
    }

    getCurrency() {
        return this._webshopService.getCurrency();
    }

    private _resetTable() {
        abp.event.trigger('dv.reset');
    }

    private _onRouteChange() {
        this.changeRouter$ = this.route.params.subscribe(params => {
            this._resetTable();
            this._combineViewService.flush();
            this._setModeAndType();
            this.getTypeByMode();
        });
    }

    private _setModeAndType() {

        const id = window.location.pathname.split('/').filter(Boolean).pop();

        if (window.location.pathname.indexOf('categories') > -1) {
            this.categoryId = id;
            this.isCategoryMode = true;
        } else if ((/^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/).test(id)) {
            this.orderGuideId = id;
            this.isCategoryMode = false;
        }
    }

    private _loadDataCategories(event?: any) {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;

        let order = this.webshopService.getOrder(event);

        const filter = this.webshopService.globalSearchFilter || undefined;

        let templateId;
        if (this.isGuided && this._fieldAgentOrderService.selectedOrderGuideTemplate) {
            templateId = this._fieldAgentOrderService.selectedOrderGuideTemplate.id;
        }

        let ogId;
        if (this.isGuided && this._fieldAgentOrderService.selectedBrand) {
            ogId = this._fieldAgentOrderService.selectedBrand.id;
        }

        //set current page
        const page = event?.event?.page ?? 0;
        this._combineViewService.setCurrentPage(page);

        const skip = event?.event?.first ?? 0;
        const takeAmount = event?.event?.rows ?? this.rowsAmount;

        this.webShopServiceProxy.getArticlesByCategory(
            window.location.pathname.split('/').filter(Boolean).pop() || undefined,
            this.webshopCode || filter || undefined,
            undefined,
            this.webshopTitle || undefined,
            ogId || undefined,
            templateId || undefined
            , order
            , skip
            , takeAmount
            )
            .pipe(
                take(1)
                , takeUntil(this.destroy$)
                , finalize(() => this.spinnerService.hide())
            )
            .subscribe((result: PagedResultDtoOfArticleDto) => {
                // this.products = result.items.map(x => this._getBasketArticles(x));
                // this.products.forEach(x => x.quantity = 1);

                this._combineViewService.setItems(result);

                if (this.primeng) {
                    this.primeng.totalRecordsCount = result.totalCount;
                } else {
                    this.primengTableHelper.totalRecordsCount = result.totalCount;
                    this.primengTableHelper.hideLoadingIndicator();
                }

                this.isLoading = false;
                this.spinnerService.hide();
            });
    }

    get globalFilter(): string | undefined {
        const filter = this.webshopService.globalSearchFilter || undefined;
        if (filter?.length > 1) {
            this.webshopService.resetGlobalSearchFilter();
        }

        return filter;
    }

    get selectedORderGuideTemplate(): string | undefined {
        return this._fieldAgentOrderService.selectedOrderGuideTemplate?.id;
    }

    private _loadDataOG(event?: any) {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;

        this.spinnerService.show();

        let order = this.webshopService.getOrder(event);

        const filter = this.globalFilter;

        let templateId;
        if (this.isGuided && this._fieldAgentOrderService.selectedOrderGuideTemplate) {
            templateId = this._fieldAgentOrderService.selectedOrderGuideTemplate.id;
        }

        //set current page
        const page = event?.event?.page ?? 0;
        this._combineViewService.setCurrentPage(page);

        const skip = event?.event?.first ?? 0;
        const takeAmount = event?.event?.rows ?? this.rowsAmount;

        this.webShopServiceProxy.getArticlesByOrderGuide(
            window.location.pathname.split('/').filter(Boolean).pop() || undefined,
            this.webshopCode || filter || undefined,
            undefined,
            this.webshopTitle || undefined,
            templateId || undefined
            , this._combineViewService.showOnlyInTrunk || 0
            //0 - all, 1 - only template, -1 - except template
            , this.toggleState
            , order
            , skip
            , takeAmount
        )
            .pipe(
                take(1)
                , takeUntil(this.destroy$)
                , finalize(() => this.spinnerService.hide())
            )
            .subscribe((result: PagedResultDtoOfArticleDto) => {
                //this.products = result.items.map(x => this._getBasketArticles(x));
                //this.products.forEach(x => x.quantity = 1);

                this._combineViewService.setItems(result);

                if (this.primeng) {
                    this.primeng.totalRecordsCount = result.totalCount;
                    this.primeng.hideLoadingIndicator();
                } else {
                    this.primengTableHelper.totalRecordsCount = result.totalCount;
                    //this.primengTableHelper.records = result.items as BasketArticleDto[];
                }

                this.isLoading = false;
                this.spinnerService.hide();
            });
    }

    addToBasket(article: BasketArticleDto) {
        this._addItemToBasket(article);
    }

    private _addItemToBasket(article: BasketArticleDto) {
        if (+article.quantity <= 0 || article.quantity === undefined) {
            return throwError('Item quantity = 0, change ');
        }

        const item = _.cloneDeep(article);
        this._webshopService.addItem(item);
        this.resetQuantity(article);
    }

    protected readonly BasePermissionDefinition = BasePermissionDefinition;
}

